module.exports = __webpack_public_path__ + "static/4-ca042e45114f7dcd3eb39926ca51f6f8.jpg";